import { render, staticRenderFns } from "./ResourcesView.vue?vue&type=template&id=78fcdac2"
import script from "./ResourcesView.vue?vue&type=script&lang=js"
export * from "./ResourcesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports